import Vue from 'vue';
import { safeHTML } from '~/functions/XSSsanitizer';

Vue.directive('html-safe', {
    inserted: function (el, binding) {
        el.innerHTML = safeHTML(binding.value);
    },

    update: function (el, binding) {
        if (binding.value !== binding.oldValue) { el.innerHTML = safeHTML(binding.value); }
    },
});
